module.exports = "/_next/static/files/3c84393a8500d1b4919be179d6197a60.png";